import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlBase } from '../../../base/control-base/control-base.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'icon-button-control',
    standalone: false,
    template: `
        <button (click)="onClickMethod()" class="btn">
            <i [class]="iconClass"></i>
        </button>
    `,
})
export class IconButtonControl extends ControlBase {
    constructor(protected override spinnerService: NgxSpinnerService) {
        super(spinnerService);
    }

    @Output() onClick = new EventEmitter<void>();
    @Input() iconClass: string = '';

    public onClickMethod(): void {
        this.onClick.emit();
    }
}
